import { render } from "./App.vue?vue&type=template&id=5f13c87a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5f13c87a&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__